import React from 'react';
import * as S from './styles';

const TextBlock = (props = {}) => (
  <S.TextBlock
    forceAlign={props.forceAlign}
    color={props.color}
    margin={props.margin}
    padding={props.padding}
    maxWidth={props.maxWidth}
  >
    {props.children}
  </S.TextBlock>
);

export default TextBlock;
